import React from 'react';
import App from './App';
import './input.css';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('app');
const root = createRoot(container);

root.render(<App tab="home" />);
